import { storeCustomerPending } from "api/Customers";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

export const useStorePending = () => {

  return useMutation(storeCustomerPending, {
    onSuccess: () => {
      toast.success("Created Successfully");
    },
    onError: () => {
      toast.error("Failed to create");
    },
  });
};
